import React from "react";
import { HomeOpening } from "./components/opening-intro.jsx";
import { Nav } from "./components/nav.jsx";
import { Hero } from "./components/hero.jsx";
import { HomeTechSignal } from "./components/home-tech-signal.jsx";
import { Strength } from "./components/strength.jsx";
import { Solutions } from "./components/solutions.jsx";
import { AIDetail } from "./components/ai-detail.jsx";
import { AIMarketingCX } from "./components/home-ai-marketing-cx.jsx";
import { WorkforceTeamSolutions } from "./components/home-workforce-team.jsx";
import { OurProducts } from "./components/products.jsx";
import { WorksPreview } from "./components/works-preview.jsx";
import { TikTok } from "./components/tiktok.jsx";
import { Previews } from "./components/previews.jsx";
import { HomeFinalCTA } from "./components/home-final-cta.jsx";
import { Footer } from "./components/contact-footer.jsx";
import { ConsultFloating } from "./components/consult-floating.jsx";
import { MobileBottomNav } from "./components/mobile-nav.jsx";

export default function App() {
  return (
    <>
      <HomeOpening />
      <Nav />
      <main>
        <Hero />
        <HomeTechSignal />
        <Strength />
        <Solutions />
        <AIDetail />
        <AIMarketingCX />
        <WorkforceTeamSolutions />
        <OurProducts />
        <WorksPreview />
        <TikTok />
        <Previews />
        <HomeFinalCTA />
      </main>
      <Footer />
      <ConsultFloating />
      <MobileBottomNav />
    </>
  );
}
